import UTCDate from './UTCDate.js';

export default class UTCDateRange {
  static get Today() {
    return this._current;
  }

  static get Yesterday() {
    return this._current.subtract(1, 'day');
  }

  static get Tomorrow() {
    return this._current.add(1, 'day');
  }

  static get ThisWeek() {
    return this.this('week');
  }

  static get LastWeek() {
    return this.range(this._current.subtract(1, 'week'), 'week');
  }

  static get NextWeek() {
    return this.range(this._current.add(1, 'week'), 'week');
  }

  static get ThisMonth() {
    return this.this('month');
  }

  static get LastMonth() {
    return this.range(this._current.subtract(1, 'month'), 'month');
  }

  static get NextMonth() {
    return this.range(this._current.add(1, 'month'), 'month');
  }

  static get ThisYear() {
    return this.this('year');
  }

  static get LastYear() {
    return this.range(this._current.subtract(1, 'year'), 'year');
  }

  static get NextYear() {
    return this.range(this._current.add(1, 'year'), 'year');
  }

  static this(unit) {
    this._validateUnit(unit);
    return this.range(this._current, unit);
  }

  static between(from, to) {
    return { greaterOrEqualThan: this._create(from), lessOrEqualThan: this._create(to) };
  }

  static notBetween(from, to) {
    return [{ lessThan: this._create(from) }, { greaterThan: this._create(to) }];
  }

  static range(from, unit) {
    this._validateUnit(unit);
    from = this._create(from);
    return this.between(from.startOf(unit), from.endOf(unit));
  }

  static last(number, unit, duration = false) {
    this._validateUnit(unit);
    const to = this._current;
    const from = to.subtract(number, unit);

    return this.between(duration ? from : from.startOf(unit), duration ? to : to.endOf(unit));
  }

  static next(number, unit, duration = false) {
    this._validateUnit(unit);
    const from = this._current;
    const to = from.add(number, unit);

    return this.between(duration ? from : from.startOf(unit), duration ? to : to.endOf(unit));
  }

  static earlierThan(number, unit) {
    return { lessThan: this._current.subtract(number, unit) };
  }

  static laterThan(number, unit) {
    return { greaterThan: this._current.add(number, unit) };
  }

  static get _current() {
    return UTCDate.today;
  }

  static _create(value) {
    return value instanceof UTCDate ? value : new UTCDate(value);
  }

  static _validateUnit(unit) {
    if (!['day', 'week', 'month', 'year'].includes(unit)) {
      throw new Error(`invalid unit ${unit}`);
    }
  }

  // @DEPRECATED
  static getRange(date, unit) {
    return {
      greaterOrEqualThan: date.startOf(unit),
      lessOrEqualThan: date.endOf(unit)
    };
  }

  // @DEPRECATED
  static getPast(number, unit, options = {}) {
    let refDate = this.Yesterday;

    if (options.includeToday) {
      refDate = this.Today;
    }

    const range = {
      lessOrEqualThan: refDate
    };

    if (!!number && !!unit) {
      let calculatedDate = refDate.subtract(number, unit);

      if (options.startOfPeriod) {
        calculatedDate = calculatedDate.startOf(unit);
      }

      range.greaterOrEqualThan = calculatedDate;
    }

    return range;
  }

  // @DEPRECATED
  static getFuture(number, unit, options = {}) {
    let refDate = this.Tomorrow;

    if (options.includeToday) {
      refDate = this.Today;
    }

    const range = {
      greaterOrEqualThan: refDate
    };

    if (!!number && !!unit) {
      let calculatedDate = refDate.add(number, unit);

      if (options.endOfPeriod) {
        calculatedDate = calculatedDate.endOf(unit);
      }

      range.lessOrEqualThan = calculatedDate;
    }

    return range;
  }

  // @DEPRECATED
  static getBetween(from, to) {
    return {
      greaterOrEqualThan: from,
      lessOrEqualThan: to
    };
  }
}
